import {Component, OnInit} from '@angular/core';

@Component({
  selector: 'app-successful-registration',
  styleUrls: ['./successful-registration.component.scss'],
  templateUrl: './successful-registration.component.html',
})

export class SuccessfulRegistrationComponent implements OnInit {
  ngOnInit(): void {
  }
}
